<template>
  <div style="width: 100%">
    <loading v-show="showLoading"></loading>

    <div class="home_content" v-if="!showLoading">
      <!--首页搜索-->
      <div class="head_top">
        <div class="head_top_search" @click="popSearchView()"><img class="head_top_search_icon" src="@/images/icon_search.png"><span class="head_top_search_placeholder">hello kitty 公仔</span></div>
      </div>

      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">

      <!--banner-->
      <div class="content_container banner_br" >
        <van-swipe class="banner_br" :autoplay="3000" >
          <van-swipe-item v-for="(bannerItem, index) in bannerList" :key="index">
            <van-image id="banner1" @click="pushWebUrl(bannerItem.contentUrl)" class="banner_item" fit="cover" :src="bannerItem.imageUrl"/>
          </van-swipe-item>
        </van-swipe>
      </div>

      <!--分类-->
      <div class="content_container clear_both" style="padding-bottom: 1rem">
        <router-link v-for="(item,classifyItemIndex) in productCatagoryList" :key="classifyItemIndex" :to="item.toPlace" >
          <div class="classify_item">
            <van-image class="full_w" style="width: 3.6rem;height: 3.6rem" fit="cover" :src="item.categoryImageUrl"/>
            <p class="clear_style tc zt10 white" style="position: absolute;width: 3.6rem;margin-top: -1.55rem">{{item.categoryName}}</p>
          </div>
        </router-link>
      </div>

      <!--分界线-->
      <div class="base_line"></div>

      <!--分类广告-->
      <div class="content_container classify_adv_content clear_both" v-if="advList">
        <div class="fl">
          <a @click="pushWebUrl(advList[0].contentUrl)">
            <van-image class="full_w" radius="0.5rem" fit="cover" :src="advList[0] && advList[0].imageUrl" />
          </a>
        </div>
        <div class="fl">
          <a @click="pushWebUrl(advList[1].contentUrl)">
            <div>
              <van-image class="full_w" radius="0.5rem" style="height: 5.3rem" :src="advList[1] && advList[1].imageUrl" />
            </div>
          </a>
          <a @click="pushWebUrl(advList[2].contentUrl)">
            <div style="margin-bottom: 0">
              <van-image class="full_w" radius="0.5rem" style="height: 5.3rem" :src="advList[2] && advList[2].imageUrl" />
            </div>
          </a>
        </div>
      </div>

      <!--分界线-->
      <div class="base_line"></div>

      <!--超值特惠-->
      <div class="gl_content clear_both" >
        <p class="gl_title">好物推荐</p>
        <div class="content_container">
          <div class="gl_info fl" v-for="(produtItem, index) in productList" :key="index">
            <router-link :to="{name:'goodsDetail',query:{goodsId:produtItem.productId,}}">
              <van-image class="full_w gl_border" fit="cover" :src="produtItem.imageUrl" />
            </router-link>
            <p class="gl_info_title">{{produtItem.productName}}</p>
            <span class="fl gl_info_price">¥{{produtItem.price}}</span>
            <span @click="addCart(produtItem.productId)" class="fr gl_info_addCart"><img style="width: 1.25rem" src="@/images/add_cart.png"></span>
          </div>
        </div>
      </div>
      </van-pull-refresh>

      <!--footer-->
      <footerView :cartInfo="{cartNum:catNum}"></footerView>
    </div>

    <div class="home_search" v-show="isShowSearch">
      <form action="/">
        <van-search
          class="search_br"
          shape="round"
          placeholder="hello kitty 公仔"
          show-action
          @search="searchAction()"
          v-model="searchValue"
          @cancel="dismissSearchView"
        />
      </form>
      <div class="content_container" >
        <p class="zt12">热门搜索</p>
        <ul class="tag_list" >
          <li class="fl" v-for="(tagItem, index) in tagList" :key="index"><router-link :to="{path:'/productList', query:{keyWord:tagItem.keyword}}"><span class="tag_item zt12">{{tagItem.keyword}}</span></router-link></li>
          <transition name="router-slid" mode="out-in">
            <router-view></router-view>
          </transition>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>

    import Vue from 'vue';
    import { storeName,prodCatalogId,loginInfo,productRecommend,shareUrl,shareOnlineUrl,wxUrl } from '@/router/Constant'
    import { login,getShoppingHomeBanner,getProductCategory,getKeyword,getActivities,getProductRecommend,getProductInfo,addProductToCart,getShoppingCartNum,getProductAttributes,getWeixinShare,boundTwoLevel,shareGetKcion} from '@/router/api';
    import { setStore,getStore,getCookie,setCookie ,setMiniProgramShare} from '@/utils/mUtil';
    import { NavBar,Swipe,SwipeItem,Image,Grid,Tabbar,Toast,Search,PullRefresh,Dialog } from 'vant';
    import footerView from '../common/footer';
    import loading from '@/components/page/common/loading.vue'

    export default {
      name: 'home',
      data () {
        return {
          token:"",
          searchValue:"",
          showLoading:true,
          isShowSearch:false,
          bannerList:[],
          advList:[],
          productCatagoryList:[],
          productList:[],
          tagList:[],
          count: 0,
          isLoading: false,
          productStoreId:storeName,
          prodCatalogId:prodCatalogId,
          catNum:0,
        }
      },
      methods: {

        async initData() {
          this.checcheckLoginStatus();
          this.getShoppingHomeBanner();
          this.getProductCategory();
          this.getActivities();
          this.getProductRecommend();
          this.getKeyword();
          this.getShoppingCartNum();
          this.setParams()
          this.getPartyId()
          setMiniProgramShare('畅“购”HelloKittyPark','http://5b0988e595225.cdn.sohucs.com/images/20181210/7d82911fcf59423ca454b7074b89025e.jpeg',wxUrl+encodeURIComponent(shareOnlineUrl))
        },

        // checkLoginStatus
        checcheckLoginStatus(){
          if (getStore('externalLoginKey')==undefined || getStore('externalLoginKey')== "") {
            setStore('islogIn',false)
            // if (getCookie('authorization')==undefined || getCookie('authorization')== "") {
            //   Toast("会员系统未登录,请先登录会员系统")
            // } else {
              // this.token = "Bearer " + getCookie('authorization');
              // this.login();
              // this.getShoppingCartNum();
            // }
          } else {
            console.log('用户当前是登录状态' + getStore('externalLoginKey'))
          }
        },
        // login (){
        //   login({token:"Bearer "+getCookie('authorization')})
        //     .then(res => {
        //       console.log("login")
        //       console.log(res)
        //       if (res._TOKEN_){
        //         setStore('externalLoginKey',res._TOKEN_)
        //         setStore('islogIn',true)
        //       } else {
        //         Toast(res._ERROR_MESSAGE_)
        //       }
        //     })
        //     .catch(err => {
        //       console.log(err);
        //     });
        // },


        getPartyId:function() {

          if(window.location.href.indexOf('partyId')!=-1){
            if(getStore('islogIn') != 'true'){
              //用户未登陆
              // this.dialogAction('是否登陆会员系统');
            }else{
              //用户已登陆

              // 获得参数
              var currentUrl = window.location.href;
              var allParamArr = currentUrl.split("&");
              var partyId = "";
              for (var i = 0; i < allParamArr.length; i++) {
                if (allParamArr[i].indexOf("partyId") != -1) {
                  partyId = allParamArr[i].split("=")[1];
                  break;
                }
              }

              var param = {
                partyId:partyId,externalLoginKey:this.token
              }
              console.log('param')
              console.log(param)

              boundTwoLevel({partyId:partyId,externalLoginKey:this.token})
                .then(res => {
                  console.log(res)
                  if(res._ERROR_MESSAGE_){
                    Toast({message:res._ERROR_MESSAGE_})
                  }else{
                    console.log('绑定成功')
                  }
                })
                .catch(err => {
                  console.log(err);
                });
            }
          }else{
            console.log('未获取到partyId')
          }

          // if (getStore('islogIn') != 'true') {
          //   //this.dialogAction('跳转购物车需要登录，是否现在登录？');
          // } else{
          // }
        },


        // 弹出搜索框
        popSearchView: function () {
          this.isShowSearch = true;
          document.querySelector('body').setAttribute('style', 'overflow:hidden');
        },
        // 隐藏框搜索框
        dismissSearchView: function () {
          this.isShowSearch = false;
          document.querySelector('body').removeAttribute('style');
        },
        //下拉刷新
        onRefresh() {
          setStore('onRefresh',"onRefresh")
          setTimeout(() => {
            window.location.reload();
          }, 1000);
        },

        getShoppingHomeBanner (){
          getShoppingHomeBanner({token:this.token,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
            .then(res => {
              console.log("getShoppingHomeBanner")
              console.log(JSON.stringify(res))
              this.bannerList = res.bannerList

            })
            .catch(err => {
              console.log(err);
            });
        },

        getProductCategory () {
          getProductCategory({token:this.token,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
            .then(res => {
              console.log("getProductCategory")
              console.log(res)
              if (res.productCategoryList) {
                if (res.productCategoryList) {
                  for (let i = 0;i<res.productCategoryList.length;i++){
                    if (i<7) { // 取前8个
                      res.productCategoryList[i]['toPlace'] = "/productList?productCategoryId=" + res.productCategoryList[i].productCategoryId;
                      this.productCatagoryList.push(res.productCategoryList[i])
                    }
                  }
                }
                //push更多
                let productItem = {
                  "productCategoryId": "～",
                  "categoryName": "更多",
                  "categoryImageUrl": require("@/images/icon_8.png"),
                  "toPlace":'/classify'
                }
                console.log(JSON.stringify(this.productCatagoryList))
                this.productCatagoryList.push(productItem);
                this.showLoading = false
              } else {
                this.showLoading = false
              }
            })
            .catch(err => {
              console.log(err);
            });
        },
        getActivities () {
          getActivities({token:this.token,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
            .then(res => {
              console.log('getActivities');
              console.log(JSON.stringify(res))
              this.advList = res.bannerList;
            })
            .catch(err => {
              console.log(err);
            });
        },
        getProductRecommend() {
          getProductRecommend({token:this.token,productStoreId:this.productStoreId,productCategoryId:productRecommend,prodCatalogId:this.prodCatalogId})
            .then(res => {
              this.productList = res.productList
              console.log(JSON.stringify(res))
              console.log('getProductRecommend');
            })
            .catch(err => {
              console.log(err);
            });
        },
        getKeyword(){
          getKeyword({token:this.token,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
            .then(res => {
              console.log(res)
              console.log('getKeyword');
              this.tagList = res.kryWordList
            })
            .catch(err => {
              console.log(err);
            });
        },
        addCart(productId) {
          if (getStore('islogIn') == 'false') {
            this.dialogAction('需要登录会员系统，是否去登录？')
          } else {
            addProductToCart({externalLoginKey:getStore('externalLoginKey'),quantity:1,productId:productId,productStoreId:this.productStoreId,prodCatalogId:this.prodCatalogId})
              .then(res => {
                console.log(res)
                if (res._ERROR_MESSAGE_) {
                  Toast(res._ERROR_MESSAGE_);
                } else {
                  Toast(res._EVENT_MESSAGE_);
                  this.getShoppingCartNum();
                }
              })
              .catch(err => {
                console.log(err);
              });
          }
        },
        getShoppingCartNum(){
          getShoppingCartNum({externalLoginKey:getStore('externalLoginKey'),productStoreId:this.productStoreId})
            .then(res => {
              console.log('getShoppingCartNum');
              console.log(res)
              this.catNum = res.catNum;
            })
            .catch(err => {
              console.log(err);
            });
        },
        dialogAction(msg){
          Dialog.confirm({
            message: msg
          }).then(() => {
            if (getStore('fromType')=='mini') {
            wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          } else {
              wx.miniProgram.switchTab({url:'../../pages/menu/menu'})
          }
          }).catch(() => {

          });
        },
        searchAction(){
          this.$router.push({path:'/productList',query:{keyWord:this.searchValue}})
        },
        pushWebUrl(url) {
          if (url){

            window.location.href = url;
          } else {
            // Toast("请设置正确跳转链接");
          }
        },

        //转发给朋友
        shareFriend:function(){
          this.showShareSheet=false
          this.showPopView = true
          this.shareGetKcion()
        },

        //文章转发获得K币
        shareGetKcion:function(){
          shareGetKcion({externalLoginKey:getStore('externalLoginKey')})
            .then(res => {
              console.log('转发成功')
              console.log(res)
            })
            .catch(err => {
              console.log(err);
            });
        },


        setParams:function(){
          let param;
          var u = navigator.userAgent, app = navigator.appVersion;
          var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Linux') > -1; //g
          var isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端
          if (isAndroid) {
            //这个是安卓操作系统
            param = 'android'
          }
          if (isIOS) {
            //这个是ios操作系统
            param = 'ios'
          }
          let paramList = {
            url: window.location.href,
            os:param
          }
          getWeixinShare(paramList).then(res => {
            console.log(res)
            wx.config({
              debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
              appId: res.shareMap.appId, // 必填，公众号的唯一标识
              timestamp: res.shareMap.timestamp, // 必填，生成签名的时间戳
              nonceStr: res.shareMap.nonceStr, // 必填，生成签名的随机串
              signature: res.shareMap.signature,// 必填，签名
              jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'] // 必填，需要使用的JS接口列表
            });

            var thisBlock = this
            wx.ready(function(){
              wx.updateAppMessageShareData({
                title: '畅“购”HelloKittyPark', // 分享标题
                desc: '官方商城，正版商品火热发售中，新入会更有50元新人礼券', // 分享描述
                link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
                // link:'https://testdms.hellokittypark.cn/catalog/control/main#11111',
                imgUrl:'http://5b0988e595225.cdn.sohucs.com/images/20181210/7d82911fcf59423ca454b7074b89025e.jpeg', // 分享图标
                success: function () {
                },error:function () {
                }
              })

              //自定义“分享到朋友圈”及“分享到QQ空间”按钮的分享内容
              wx.updateTimelineShareData({
                title: '畅“购”HelloKittyPark',
                desc: '官方商城，正版商品火热发售中，新入会更有50元新人礼券',
                link: window.location.href,
                // link:'https://testdms.hellokittypark.cn/catalog/control/main#11111',
                imgUrl: 'http://5b0988e595225.cdn.sohucs.com/images/20181210/7d82911fcf59423ca454b7074b89025e.jpeg',
                success: function () {
                },error:function () {
                }
              })
            });

          })
        },

      },
      components: {
        [NavBar.name]: NavBar,
        [Swipe.name]: Swipe,
        [SwipeItem.name]: SwipeItem,
        [Image.name]: Image,
        [Grid.name]: Grid,
        [Tabbar.name]: Tabbar,
        [Toast.name]: Toast,
        [Search.name]: Search,
        [PullRefresh.name]: PullRefresh,
        [Dialog.name]: Dialog,
        footerView,
        loading,
      },
      mounted() {
        this.initData();
      },
      beforeDestroy(){
        this.isShowSearch = false;
        document.querySelector('body').removeAttribute('style')
      },

    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>

  .home_content {
    padding-top: 3rem;
  }

  .home_search {
    width: 100%;height: 100%;position: fixed;top: 0;background-color: white;z-index: 99;
  }

  .head_top {
    background-color: white;padding-top: 0.5rem;padding-bottom: 0.5rem;position: fixed;top: 0;left: 0;width: 100%;z-index: 99
  }

  .head_top_search {
    width: 20rem;margin-left: 0.85rem;background-color: #f5f5f5;height: 2rem;line-height: 2rem;padding: 0 0.8rem;border-radius: 1rem
  }

  .head_top_search_icon {
    width: 0.8rem;height: 0.8rem;margin-right: 0.5rem
  }

  .head_top_search_placeholder {
    font-size: 0.75rem;color: #999999
  }

  .content_container {
    padding: 0 1rem
  }

  .banner_item {
    width: 21.5rem;
    height: 10rem;
  }

  .banner_br {
    padding-bottom: 1rem;
  }

  .base_line {
    height: 0.6rem;
    background-color: #f4f4f4;
  }

  .adv_height {
    height: 5rem;
  }

  .classify_item {
    float: left;
    width: 3.3rem;
    height: 4rem;
    padding: 0.5rem 1rem;
  }

  .classify_adv_content {
    padding-top: 1rem;
    padding-bottom: 1rem;
  }

  .classify_adv_content > div:nth-child(1) {
    width:8.75rem;
    height: 11.25rem;
    margin-right: 0.6rem;
  }

  .classify_adv_content > div:nth-child(1) > a  > div {
    width:8.75rem;
    height: 11.25rem;
  }

  .classify_adv_content > a > div:nth-child(2) {
    width:12rem;
    height: 11.25rem;
  }

  .classify_adv_content > div:nth-child(2) > a  > div:nth-child(1) {
    width: 12rem;height: 5.3rem;margin-bottom: 0.6rem
  }

  .classify_adv_content a > div:nth-child(2) > a > div:nth-child(2) {
    width: 12rem;height: 5.3rem;margin-bottom: 0;
  }

  .gl_content {
    padding-bottom: 3rem;
  }

  .gl_border {
    border-radius: 0.4rem 0.4rem 0 0;
    width: 10.25rem;height: 10.25rem;
  }

  .gl_title {
    padding-left: 1rem;font-weight: bold;border-left-width: 0.1rem;border-left-style: solid;border-left-color: #EB84AB
  }

  .gl_info {
    width: 10.25rem;height: 14.5rem;border-width: 1px;border-color: #F4F4F4;border-style: solid;padding-bottom: 0.5rem;margin-bottom: 0.6rem;border-radius: 0.5rem;overflow: hidden;
  }

  .gl_info:nth-child(odd) {
    margin-right: 0.5rem;
  }

  .gl_info_title {
    padding: 0 0.1rem;margin:0 0.5rem 0;font-size: 0.875rem;color: #666666;height: 2.1rem;
  }

  .gl_info_price {
    margin-left: 0.5rem;font-size: 0.875rem;color: #EB84AB;margin-top: 0.5rem;
  }

  .gl_info_addCart {
    margin-right: 0.5rem;font-size: 0.875rem;color: #EB84AB;margin-top: 0.5rem;
  }

  .tag_list > li {
    line-height: 2rem;
    margin: 0 0.6rem 0.6rem 0;
  }

  .tag_item {
    background-color: #f5f5f5;padding: 0.5rem 1rem;border-radius: 0.3rem;
  }

  .router-slid-enter-active, .router-slid-leave-active {
    transition: all .4s;
  }
  .router-slid-enter, .router-slid-leave-active {
    transform: translate3d(2rem, 0, 0);
    opacity: 0;
  }

</style>



// WEBPACK FOOTER //
// src/components/page/home/home.vue